import { createSlice } from '@reduxjs/toolkit'

export const LanguageFilterSlice = createSlice(
  {
  name: 'selected_language',
  initialState: {
    value: '',
  },
  reducers: {
    languageSelected: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { languageSelected } = LanguageFilterSlice.actions

export default LanguageFilterSlice.reducer